let showOverlayFn: (() => void) | null = null;

export function registerUpdateOverlayService(fn: (() => void) | null) {
  showOverlayFn = fn;
}

export function isUpdateOverlayRegistered(): boolean {
  return showOverlayFn !== null;
}

export function showUpdateOverlayOutsideReact(): boolean {
  if (showOverlayFn) {
    showOverlayFn();
    return true;
  }
  return false;
}
